import { useRequiredParams } from '@pba/react-router';
import { CommunityFeed, CommunityLayout } from 'features/communities';

const PageCommunityFeed = () => {
  const { communityId } = useRequiredParams<{ communityId: string }>();

  return (
    <CommunityLayout communityId={communityId} tab="/feed">
      {(community) => <CommunityFeed community={community} />}
    </CommunityLayout>
  );
};

export default PageCommunityFeed;
